import { useEffect } from 'react';

import { useAtomValue, useSetAtom } from 'jotai';

import useLogin from 'src/hooks/useLogin';
import {
  cmpConsentsAtom,
  getCmpConsentsAtom,
  isGettingCmpConsentsAtom,
} from 'src/stores/auth/atoms';

const useCmpConsents = () => {
  const getCmpConsents = useSetAtom(getCmpConsentsAtom);
  const cmpConsents = useAtomValue(cmpConsentsAtom);
  const isGettingCmpConsents = useAtomValue(isGettingCmpConsentsAtom);
  const { isLogin } = useLogin();

  useEffect(() => {
    if (isLogin && cmpConsents === undefined && !isGettingCmpConsents) {
      getCmpConsents();
      return;
    }
  }, [cmpConsents, getCmpConsents, isLogin, isGettingCmpConsents]);

  return {
    cmpConsents,
  };
};

export default useCmpConsents;
